import { ease, clamp01 } from "../fourier/timeline";

export type HookPattern = "A" | "B" | "C" | "D" | "E";
export const HOOK_FRAMES = 30;
export const TOTAL_FRAMES = 120;
export const ramp = (frame: number, from: number, to: number) =>
  ease((frame - from) / (to - from));
export const mix = (a: number, b: number, t: number) => a + (b - a) * t;

/** One clock, including the approach to the seam. Never resets at frame 30. */
export const drawingProgress = (frame: number) =>
  frame >= 119 ? 1 : clamp01(0.005 + Math.max(0, frame) * (0.995 / 119));

/** A stable per-pixel variation; independent of render order and concurrency. */
export const scatter = (index: number) => ({
  x: Math.sin(index * 12.9898 + 1.7) * 330,
  y: Math.cos(index * 7.233 + 0.9) * 380,
});

export const hookState = (pattern: HookPattern, frame: number) => {
  // Identity is reached before the cut, with two fully settled approach frames.
  if (frame >= 28) return { camera: 1, chain: 1, trace: 1, overlay: 0 };
  const settle = ramp(frame, 21, 28);
  return {
    camera:
      pattern === "A"
        ? mix(12, 1, ramp(frame, 7, 23))
        : pattern === "C"
          ? Math.exp(mix(Math.log(64), 0, ramp(frame, 13, 27)))
          : 1,
    chain:
      pattern === "A"
        ? ramp(frame, 11, 23)
        : pattern === "B"
          ? ramp(frame, 18, 27)
          : pattern === "D"
            ? ramp(frame, 11, 23)
            : pattern === "E"
              ? ramp(frame, 18, 27)
              : 1,
    trace: pattern === "B" || pattern === "D" || pattern === "E" ? settle : 1,
    overlay: 1 - settle,
  };
};
